import request from '@/utils/request'

export function list(query) {
    return request({
        url: '/point/sign/list',
        method: 'get',
        params: query
    })
}

export function info(id) {
    return request({
        url: '/point/sign/info/' + id,
        method: 'get'
    })
}

export function save(data) {
    return request({
        url: '/point/sign/save',
        method: 'post',
        data
    })
}

export function update(data) {
    return request({
        url: '/point/sign/update',
        method: 'post',
        data
    })
}

export function remove(data) {
    return request({
        url: '/point/sign/delete',
        method: 'post',
        data
    })
}

